import api from "@/lib/axios";

export enum CreditsKeys {
  Balance = "credits-balance",
  History = "credits-history",
}

export interface CreditsBalanceResponse {
  balance: number;
  totalGranted: number;
  resetDate: string;
}

export interface CreditTransaction {
  type: "credit_grant" | "credit_deduct" | "credit_adjust" | "credit_reset";
  amount: number;
  balanceAfter: number;
  reference?: string;
  createdAt: string;
}

export interface CreditsHistoryResponse {
  transactions: CreditTransaction[];
  total: number;
}

export const getCreditsBalance = async (): Promise<CreditsBalanceResponse> => {
  const response = await api.get("/credits");
  return response.data;
};

export const getCreditsHistory = async (
  limit = 20,
  offset = 0,
): Promise<CreditsHistoryResponse> => {
  const response = await api.get("/credits/history", {
    params: { limit, offset },
  });
  return response.data;
};
